
import 'eonasdan-bootstrap-datetimepicker'
import 'eonasdan-bootstrap-datetimepicker/build/css/bootstrap-datetimepicker.min.css'
riot.tag2('datetime-picker', '  <input value="{value}" onchange="{change}" onfocus="{show}">\n', ':scope { position: inherit; } input { font-family: inherit; padding: 0; margin: 0; border: none; width: inherit; height: auto; color: inherit; background-color: inherit; } span { cursor: pointer; }', '', function(opts) {
'use strict';

var self = this;
self.value = '';

Object.defineProperty(self.root, 'value', {
    get: function get() {
        return self.value;
    },
    set: function set(value) {
        self.value = value;
        if (opts.value) opts.value = value;
        self.update();
    }
});

self.on('mount', function () {

    var input = self.root.children[0];
    if (opts.value) self.value = opts.value;else if (opts.defvalue) self.value = opts.defvalue;

    $(self.root).datetimepicker({
        locale: opts.locale || 'ru',
        useCurrent: true,
        showTodayButton: true,
        showClear: true,
        format: opts.format || false,
        widgetParent: $(self.root)
    });

    $(self.root).on('dp.change', function (e) {
        self.one('update', function () {
            if (opts.value) opts.value = input.value;
            self.value = input.value;
            var event = document.createEvent('Event');
            event.initEvent('change', true, true);
            self.root.dispatchEvent(event);
        });
        self.update();
    });

    self.show = function (e) {
        $(self.root).data("DateTimePicker").show();
    };

    self.hide = function (e) {
        $(self.root).data("DateTimePicker").hide();
    };
});

self.on('mount', function () {
    self.root.name = opts.name;
});
});


// WEBPACK FOOTER //
// ./components/datetime-picker.tag